import React from 'react';
import './ClassForm.css'

const ClassForm = ({ values, handleChange, handleSubmit }) => {

    return (<form id='new-class-form' onSubmit={handleSubmit}>
        <div class="class-input">
            <label htmlFor="class-name" class="form-label">Class Name*</label>
            <input type="text" name="name" class="form-control" id="class-name" onChange={handleChange} value={values.name} required={true} />
        </div>
        <div class="class-input">
            <label htmlFor="room-id" class="form-label">Room ID*</label>
            <input type="text" name="room_ID" class="form-control" id="room-id" onChange={handleChange} value={values.room_ID} aria-describedby="emailHelp" required={true} />
            {/* <div id="emailHelp" class="form-text">Should be unquie</div> */}
        </div>
        <div class="class-input">
            <label htmlFor="subject" class="form-label">Subject*</label>
            <input type="text" name="subject" class="form-control" id="subject" onChange={handleChange} value={values.subject} required={true} />
        </div>
        <div class="class-input">
            <label htmlFor="section" class="form-label">Section</label>
            <input type="text" name="section" class="form-control" id="section" onChange={handleChange} value={values.section} />
        </div>
        <div class="class-input">
            <label htmlFor="class-level" class="form-label">Class Level</label>
            <input type="text" name="std" class="form-control" id="class-level" onChange={handleChange} value={values.std} />
        </div>
        <div class="class-input">
            <button type="submit" class="btn btn-primary">Create</button>
        </div>
    </form>);
};

export default ClassForm;